import { ReactElement } from 'react';
import CustomModal from '../../components-library/CustomModal';
import { useTranslation } from 'react-i18next';
import useAppMethods from '../../hooks/utility/useAppMethods';
import useOpeningStatus from '../../hooks/availability/useOpeningStatus';
import CustomButton from '../../components-library/buttons/CustomButton';
import ClosedSign from './ClosedSign';
import { MODAL_SIZES } from '../../services/exports/Constants';

const RestaurantClosedModal = (): ReactElement => {
  const { t } = useTranslation(undefined, { keyPrefix: 'Modals:RestaurantClosed:RestaurantClosedModal' });
  const { toggleRestaurantClosedModal } = useAppMethods();
  const { details_text } = useOpeningStatus({ closedPrefixType: 'closed' });

  function toggleModal(): void {
    toggleRestaurantClosedModal({ openModal: false });
  }

  return (
    <CustomModal open onClose={toggleModal} zIndex={5000} size={MODAL_SIZES.XS}>
      <div className="flex flex-col items-center justify-center space-y-lg lg:p-lg p-md">
        <ClosedSign label={t('icon_text')} />
        <p>{details_text}</p>
        <CustomButton title={t('buttons.ok')} onClick={toggleModal} />
      </div>
    </CustomModal>
  );
};

export default RestaurantClosedModal;
